module.exports = __webpack_public_path__ + "03c7b4a960be4ba60a8682d8841c31ee.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/OM.svg
// module id = Z6Fn
// module chunks = 0